export const nav = {
    permissao: 'hdocs.armazenamento:ver',
    section: 'Configuracao',
    title: 'Armazenamento',
    icon: 'cloud',
    route: '/armazenamento',
    sequence: 15, // ver comentario em modules/categorias/routes.js
};

export default [
    {
        path: '/armazenamento',
        name: 'armazenamento',
        component: () => import('./pages/ArmazenamentoPage.vue'),
        meta: { requiresAuth: true, permissao: 'hdocs.armazenamento:ver' },
    },
];
